export interface Country {
    code: string;
    name: string;
    enablePostalCode: boolean;
    enableProvinces: boolean;
    postalCodeRegex?: RegExp;
    postalCodeFormats?: string;
    provinces: { code: string, name: string }[];
}

export const countries: Country[] =
    [
        {
            code: 'AD',
            name: $localize`Andorra`,
            enablePostalCode: true,
            enableProvinces: false,
            postalCodeRegex: /^AD[1-7]0\d$/,
            postalCodeFormats: null,
            provinces: []
        },
        {
            code: 'AE',
            name: $localize`United Arab Emirates`,
            enablePostalCode: false,
            enableProvinces: false,
            postalCodeRegex: null,
            postalCodeFormats: null,
            provinces: []
        },
        {
            code: 'AF',
            name: $localize`Afghanistan`,
            enablePostalCode: false,
            enableProvinces: false,
            postalCodeRegex: /^\d{4}$/,
            postalCodeFormats: null,
            provinces: []
        },
        {
            code: 'AG',
            name: $localize`Antigua And Barbuda`,
            enablePostalCode: false,
            enableProvinces: false,
            postalCodeRegex: null,
            postalCodeFormats: null,
            provinces: []
        },
        {
            code: 'AI',
            name: $localize`Anguilla`,
            enablePostalCode: false,
            enableProvinces: false,
            postalCodeRegex: null,
            postalCodeFormats: null,
            provinces: []
        },
        {
            code: 'AL',
            name: $localize`Albania`,
            enablePostalCode: false,
            enableProvinces: false,
            postalCodeRegex: /^\d{4}$/,
            postalCodeFormats: null,
            provinces: []
        },
        {
            code: 'AM',
            name: $localize`Armenia`,
            enablePostalCode: true,
            enableProvinces: false,
            postalCodeRegex: /^(37)?\d{4}$/,
            postalCodeFormats: null,
            provinces: []
        },
        {
            code: 'AN',
            name: $localize`Netherlands Antilles`,
            enablePostalCode: false,
            enableProvinces: false,
            postalCodeRegex: null,
            postalCodeFormats: null,
            provinces: []
        },
        {
            code: 'AO',
            name: $localize`Angola`,
            enablePostalCode: false,
            enableProvinces: false,
            postalCodeRegex: null,
            postalCodeFormats: null,
            provinces: []
        },
        {
            code: 'AQ',
            name: $localize`Antarctica`,
            enablePostalCode: false,
            enableProvinces: false,
            postalCodeRegex: null,
            postalCodeFormats: null,
            provinces: []
        },
        {
            code: 'AR',
            name: $localize`Argentina`,
            enablePostalCode: true,
            enableProvinces: false,
            postalCodeRegex: /^((?:[A-HJ-NP-Z])?\d{4})([A-Z]{3})?$/,
            postalCodeFormats: null,
            provinces: []
        },
        {
            code: 'AS',
            name: $localize`American Samoa`,
            enablePostalCode: true,
            enableProvinces: false,
            postalCodeRegex: /^(96799)(?:[ \-](\d{4}))?$/,
            postalCodeFormats: null,
            provinces: []
        },
        {
            code: 'AT',
            name: $localize`Austria`,
            enablePostalCode: true,
            enableProvinces: false,
            postalCodeRegex: /^\d{4}$/,
            postalCodeFormats: null,
            provinces: []
        },
        {
            code: 'AU',
            name: $localize`Australia`,
            enablePostalCode: true,
            enableProvinces: false,
            postalCodeRegex: /^\d{4}$/,
            postalCodeFormats: null,
            provinces: []
        },
        {
            code: 'AW',
            name: $localize`Aruba`,
            enablePostalCode: false,
            enableProvinces: false,
            postalCodeRegex: null,
            postalCodeFormats: null,
            provinces: []
        },
        {
            code: 'AZ',
            name: $localize`Azerbaijan`,
            enablePostalCode: true,
            enableProvinces: false,
            postalCodeRegex: /^\d{4}$/,
            postalCodeFormats: null,
            provinces: []
        },
        {
            code: 'BA',
            name: $localize`Bosnia And Herzegowina`,
            enablePostalCode: true,
            enableProvinces: false,
            postalCodeRegex: /^\d{5}$/,
            postalCodeFormats: null,
            provinces: []
        },
        {
            code: 'BB',
            name: $localize`Barbados`,
            enablePostalCode: false,
            enableProvinces: false,
            postalCodeRegex: /^(?:BB\d{5})?$/,
            postalCodeFormats: null,
            provinces: []
        },
        {
            code: 'BD',
            name: $localize`Bangladesh`,
            enablePostalCode: true,
            enableProvinces: false,
            postalCodeRegex: /^\d{4}$/,
            postalCodeFormats: null,
            provinces: []
        },
        {
            code: 'BE',
            name: $localize`Belgium`,
            enablePostalCode: true,
            enableProvinces: false,
            postalCodeRegex: /^\d{4}$/,
            postalCodeFormats: null,
            provinces: []
        },
        {
            code: 'BF',
            name: $localize`Burkina Faso`,
            enablePostalCode: false,
            enableProvinces: false,
            postalCodeRegex: null,
            postalCodeFormats: null,
            provinces: []
        },
        {
            code: 'BG',
            name: $localize`Bulgaria`,
            enablePostalCode: true,
            enableProvinces: false,
            postalCodeRegex: /^\d{4}$/,
            postalCodeFormats: null,
            provinces: []
        },
        {
            code: 'BH',
            name: $localize`Bahrain`,
            enablePostalCode: false,
            enableProvinces: false,
            postalCodeRegex: /^(?:(?:\d|1[0-2])\d{2})?$/,
            postalCodeFormats: null,
            provinces: []
        },
        {
            code: 'BI',
            name: $localize`Burundi`,
            enablePostalCode: false,
            enableProvinces: false,
            postalCodeRegex: null,
            postalCodeFormats: null,
            provinces: []
        },
        {
            code: 'BJ',
            name: $localize`Benin`,
            enablePostalCode: false,
            enableProvinces: false,
            postalCodeRegex: null,
            postalCodeFormats: null,
            provinces: []
        },
        {
            code: 'BM',
            name: $localize`Bermuda`,
            enablePostalCode: false,
            enableProvinces: false,
            postalCodeRegex: /^[A-Z]{2}[ ]?[A-Z0-9]{2}$/,
            postalCodeFormats: null,
            provinces: []
        },
        {
            code: 'BN',
            name: $localize`Brunei Darussalam`,
            enablePostalCode: true,
            enableProvinces: false,
            postalCodeRegex: /^[A-Z]{2}[ ]?\d{4}$/,
            postalCodeFormats: null,
            provinces: []
        },
        {
            code: 'BO',
            name: $localize`Bolivia`,
            enablePostalCode: false,
            enableProvinces: false,
            postalCodeRegex: null,
            postalCodeFormats: null,
            provinces: []
        },
        {
            code: 'BR',
            name: $localize`Brazil`,
            enablePostalCode: true,
            enableProvinces: false,
            postalCodeRegex: /^\d{5}([\-]?\d{3})?$/,
            postalCodeFormats: null,
            provinces: []
        },
        {
            code: 'BS',
            name: $localize`Bahamas`,
            enablePostalCode: false,
            enableProvinces: false,
            postalCodeRegex: null,
            postalCodeFormats: null,
            provinces: []
        },
        {
            code: 'BT',
            name: $localize`Bhutan`,
            enablePostalCode: false,
            enableProvinces: false,
            postalCodeRegex: /^\d{5}$/,
            postalCodeFormats: null,
            provinces: []
        },
        {
            code: 'BV',
            name: $localize`Bouvet Island`,
            enablePostalCode: false,
            enableProvinces: false,
            postalCodeRegex: null,
            postalCodeFormats: null,
            provinces: []
        },
        {
            code: 'BW',
            name: $localize`Botswana`,
            enablePostalCode: false,
            enableProvinces: false,
            postalCodeRegex: null,
            postalCodeFormats: null,
            provinces: []
        },
        {
            code: 'BY',
            name: $localize`Belarus`,
            enablePostalCode: true,
            enableProvinces: false,
            postalCodeRegex: /^\d{6}$/,
            postalCodeFormats: null,
            provinces: []
        },
        {
            code: 'BZ',
            name: $localize`Belize`,
            enablePostalCode: false,
            enableProvinces: false,
            postalCodeRegex: null,
            postalCodeFormats: null,
            provinces: []
        },
        {
            code: 'CA',
            name: $localize`Canada`,
            enablePostalCode: true,
            enableProvinces: true,
            postalCodeRegex: /^[ABCEGHJKLMNPRSTVXY]\d[ABCEGHJ-NPRSTV-Z][ ]?\d[ABCEGHJ-NPRSTV-Z]\d$/,
            postalCodeFormats: null,
            provinces: [
                { code: 'AB', name: $localize`Alberta` },
                { code: 'BC', name: $localize`British Columbia` },
                { code: 'MB', name: $localize`Manitoba` },
                { code: 'NB', name: $localize`New Brunswick` },
                { code: 'NL', name: $localize`Newfoundland and Labrador` },
                { code: 'NT', name: $localize`Northwest Territories` },
                { code: 'NS', name: $localize`Nova Scotia` },
                { code: 'NU', name: $localize`Nunavut` },
                { code: 'ON', name: $localize`Ontario` },
                { code: 'PE', name: $localize`Prince Edward Island` },
                { code: 'QC', name: $localize`Quebec` },
                { code: 'SK', name: $localize`Saskatchewan` },
                { code: 'YT', name: $localize`Yukon` }
            ]
        },
        {
            code: 'CC',
            name: $localize`Cocos (Keeling) Islands`,
            enablePostalCode: false,
            enableProvinces: false,
            postalCodeRegex: null,
            postalCodeFormats: null,
            provinces: []
        },
        {
            code: 'CD',
            name: $localize`Congo, The Democratic Republic Of The`,
            enablePostalCode: false,
            enableProvinces: false,
            postalCodeRegex: null,
            postalCodeFormats: null,
            provinces: []
        },
        {
            code: 'CF',
            name: $localize`Central African Republic`,
            enablePostalCode: false,
            enableProvinces: false,
            postalCodeRegex: null,
            postalCodeFormats: null,
            provinces: []
        },
        {
            code: 'CG',
            name: $localize`Congo`,
            enablePostalCode: false,
            enableProvinces: false,
            postalCodeRegex: null,
            postalCodeFormats: null,
            provinces: []
        },
        {
            code: 'CH',
            name: $localize`Switzerland`,
            enablePostalCode: true,
            enableProvinces: false,
            postalCodeRegex: /^\d{4}$/,
            postalCodeFormats: null,
            provinces: []
        },
        {
            code: 'CI',
            name: $localize`Cote D'Ivoire`,
            enablePostalCode: false,
            enableProvinces: false,
            postalCodeRegex: null,
            postalCodeFormats: null,
            provinces: []
        },
        {
            code: 'CK',
            name: $localize`Cook Islands`,
            enablePostalCode: false,
            enableProvinces: false,
            postalCodeRegex: /^\d{4}$/,
            postalCodeFormats: null,
            provinces: []
        },
        {
            code: 'CL',
            name: $localize`Chile`,
            enablePostalCode: true,
            enableProvinces: false,
            postalCodeRegex: /^\d{7}$/,
            postalCodeFormats: null,
            provinces: []
        },
        {
            code: 'CM',
            name: $localize`Cameroon`,
            enablePostalCode: false,
            enableProvinces: false,
            postalCodeRegex: null,
            postalCodeFormats: null,
            provinces: []
        },
        {
            code: 'CN',
            name: $localize`China`,
            enablePostalCode: true,
            enableProvinces: false,
            postalCodeRegex: /^\d{6}$/,
            postalCodeFormats: null,
            provinces: []
        },
        {
            code: 'CO',
            name: $localize`Colombia`,
            enablePostalCode: true,
            enableProvinces: false,
            postalCodeRegex: /^\d{6}$/,
            postalCodeFormats: null,
            provinces: []
        },
        {
            code: 'CR',
            name: $localize`Costa Rica`,
            enablePostalCode: false,
            enableProvinces: false,
            postalCodeRegex: /^\d{4,5}|\d{3}-\d{4}$/,
            postalCodeFormats: null,
            provinces: []
        },
        {
            code: 'CU',
            name: $localize`Cuba`,
            enablePostalCode: true,
            enableProvinces: false,
            postalCodeRegex: null,
            postalCodeFormats: null,
            provinces: []
        },
        {
            code: 'CV',
            name: $localize`Cape Verde`,
            enablePostalCode: false,
            enableProvinces: false,
            postalCodeRegex: /^\d{4}$/,
            postalCodeFormats: null,
            provinces: []
        },
        {
            code: 'CX',
            name: $localize`Christmas Island`,
            enablePostalCode: false,
            enableProvinces: false,
            postalCodeRegex: null,
            postalCodeFormats: null,
            provinces: []
        },
        {
            code: 'CY',
            name: $localize`Cyprus`,
            enablePostalCode: true,
            enableProvinces: false,
            postalCodeRegex: /^\d{4}$/,
            postalCodeFormats: null,
            provinces: []
        },
        {
            code: 'CZ',
            name: $localize`Czech Republic`,
            enablePostalCode: true,
            enableProvinces: false,
            postalCodeRegex: /^\d{3}[ ]?\d{2}$/,
            postalCodeFormats: null,
            provinces: []
        },
        {
            code: 'DE',
            name: $localize`Germany`,
            enablePostalCode: true,
            enableProvinces: false,
            postalCodeRegex: /^\d{5}$/,
            postalCodeFormats: null,
            provinces: []
        },
        {
            code: 'DJ',
            name: $localize`Djibouti`,
            enablePostalCode: false,
            enableProvinces: false,
            postalCodeRegex: null,
            postalCodeFormats: null,
            provinces: []
        },
        {
            code: 'DK',
            name: $localize`Denmark`,
            enablePostalCode: true,
            enableProvinces: false,
            postalCodeRegex: /^\d{4}$/,
            postalCodeFormats: null,
            provinces: []
        },
        {
            code: 'DM',
            name: $localize`Dominica`,
            enablePostalCode: false,
            enableProvinces: false,
            postalCodeRegex: null,
            postalCodeFormats: null,
            provinces: []
        },
        {
            code: 'DO',
            name: $localize`Dominican Republic`,
            enablePostalCode: false,
            enableProvinces: false,
            postalCodeRegex: /^\d{5}$/,
            postalCodeFormats: null,
            provinces: []
        },
        {
            code: 'DZ',
            name: $localize`Algeria`,
            enablePostalCode: true,
            enableProvinces: false,
            postalCodeRegex: /^\d{5}$/,
            postalCodeFormats: null,
            provinces: []
        },
        {
            code: 'EC',
            name: $localize`Ecuador`,
            enablePostalCode: true,
            enableProvinces: false,
            postalCodeRegex: /^(?:[A-Z]\d{4}[A-Z]|(?:[A-Z]{2})?\d{6})?$/,
            postalCodeFormats: null,
            provinces: []
        },
        {
            code: 'EE',
            name: $localize`Estonia`,
            enablePostalCode: true,
            enableProvinces: false,
            postalCodeRegex: /^\d{5}$/,
            postalCodeFormats: null,
            provinces: []
        },
        {
            code: 'EG',
            name: $localize`Egypt`,
            enablePostalCode: false,
            enableProvinces: false,
            postalCodeRegex: /^\d{5}$/,
            postalCodeFormats: null,
            provinces: []
        },
        {
            code: 'EH',
            name: $localize`Western Sahara`,
            enablePostalCode: false,
            enableProvinces: false,
            postalCodeRegex: null,
            postalCodeFormats: null,
            provinces: []
        },
        {
            code: 'ER',
            name: $localize`Eritrea`,
            enablePostalCode: false,
            enableProvinces: false,
            postalCodeRegex: null,
            postalCodeFormats: null,
            provinces: []
        },
        {
            code: 'ES',
            name: $localize`Spain`,
            enablePostalCode: true,
            enableProvinces: false,
            postalCodeRegex: /^\d{5}$/,
            postalCodeFormats: null,
            provinces: []
        },
        {
            code: 'ET',
            name: $localize`Ethiopia`,
            enablePostalCode: false,
            enableProvinces: false,
            postalCodeRegex: /^\d{4}$/,
            postalCodeFormats: null,
            provinces: []
        },
        {
            code: 'FI',
            name: $localize`Finland`,
            enablePostalCode: true,
            enableProvinces: false,
            postalCodeRegex: /^\d{5}$/,
            postalCodeFormats: null,
            provinces: []
        },
        {
            code: 'FJ',
            name: $localize`Fiji`,
            enablePostalCode: false,
            enableProvinces: false,
            postalCodeRegex: null,
            postalCodeFormats: null,
            provinces: []
        },
        {
            code: 'FK',
            name: $localize`Falkland Islands (Malvinas)`,
            enablePostalCode: false,
            enableProvinces: false,
            postalCodeRegex: /^FIQQ 1ZZ$/,
            postalCodeFormats: null,
            provinces: []
        },
        {
            code: 'FM',
            name: $localize`Micronesia, Federated States Of`,
            enablePostalCode: true,
            enableProvinces: false,
            postalCodeRegex: /^(9694[1-4])(?:[ \-](\d{4}))?$/,
            postalCodeFormats: null,
            provinces: []
        },
        {
            code: 'FO',
            name: $localize`Faroe Islands`,
            enablePostalCode: true,
            enableProvinces: false,
            postalCodeRegex: /^\d{3}$/,
            postalCodeFormats: null,
            provinces: []
        },
        {
            code: 'FR',
            name: $localize`France`,
            enablePostalCode: true,
            enableProvinces: false,
            postalCodeRegex: /^\d{2}[ ]?\d{3}$/,
            postalCodeFormats: null,
            provinces: []
        },
        {
            code: 'FX',
            name: $localize`France, Metropolitan`,
            enablePostalCode: false,
            enableProvinces: false,
            postalCodeRegex: null,
            postalCodeFormats: null,
            provinces: []
        },
        {
            code: 'GA',
            name: $localize`Gabon`,
            enablePostalCode: false,
            enableProvinces: false,
            postalCodeRegex: null,
            postalCodeFormats: null,
            provinces: []
        },
        {
            code: 'GB',
            name: $localize`United Kingdom`,
            enablePostalCode: true,
            enableProvinces: false,
            postalCodeRegex: /^GIR[ ]?0AA|((AB|AL|B|BA|BB|BD|BH|BL|BN|BR|BS|BT|BX|CA|CB|CF|CH|CM|CO|CR|CT|CV|CW|DA|DD|DE|DG|DH|DL|DN|DT|DY|E|EC|EH|EN|EX|FK|FY|G|GL|GY|GU|HA|HD|HG|HP|HR|HS|HU|HX|IG|IM|IP|IV|JE|KA|KT|KW|KY|L|LA|LD|LE|LL|LN|LS|LU|M|ME|MK|ML|N|NE|NG|NN|NP|NR|NW|OL|OX|PA|PE|PH|PL|PO|PR|RG|RH|RM|S|SA|SE|SG|SK|SL|SM|SN|SO|SP|SR|SS|ST|SW|SY|TA|TD|TF|TN|TQ|TR|TS|TW|UB|W|WA|WC|WD|WF|WN|WR|WS|WV|YO|ZE)(\d[\dA-Z]?[ ]?\d[ABD-HJLN-UW-Z]{2}))|BFPO[ ]?\d{1,4}$/,
            postalCodeFormats: null,
            provinces: []
        },
        {
            code: 'GD',
            name: $localize`Grenada`,
            enablePostalCode: false,
            enableProvinces: false,
            postalCodeRegex: null,
            postalCodeFormats: null,
            provinces: []
        },
        {
            code: 'GE',
            name: $localize`Georgia`,
            enablePostalCode: false,
            enableProvinces: false,
            postalCodeRegex: null,
            postalCodeFormats: null,
            provinces: []
        },
        {
            code: 'GF',
            name: $localize`French Guiana`,
            enablePostalCode: false,
            enableProvinces: false,
            postalCodeRegex: null,
            postalCodeFormats: null,
            provinces: []
        },
        {
            code: 'GG',
            name: $localize`Bailiwick of Guernsey`,
            enablePostalCode: true,
            enableProvinces: false,
            postalCodeRegex: null,
            postalCodeFormats: null,
            provinces: []
        },
        {
            code: 'GH',
            name: $localize`Ghana`,
            enablePostalCode: false,
            enableProvinces: false,
            postalCodeRegex: null,
            postalCodeFormats: null,
            provinces: []
        },
        {
            code: 'GI',
            name: $localize`Gibraltar`,
            enablePostalCode: false,
            enableProvinces: false,
            postalCodeRegex: /^GX11 1AA$/,
            postalCodeFormats: null,
            provinces: []
        },
        {
            code: 'GL',
            name: $localize`Greenland`,
            enablePostalCode: true,
            enableProvinces: false,
            postalCodeRegex: /^39\d{2}$/,
            postalCodeFormats: null,
            provinces: []
        },
        {
            code: 'GM',
            name: $localize`Gambia`,
            enablePostalCode: false,
            enableProvinces: false,
            postalCodeRegex: null,
            postalCodeFormats: null,
            provinces: []
        },
        {
            code: 'GN',
            name: $localize`Guinea`,
            enablePostalCode: false,
            enableProvinces: false,
            postalCodeRegex: /^\d{3}$/,
            postalCodeFormats: null,
            provinces: []
        },
        {
            code: 'GP',
            name: $localize`Guadeloupe`,
            enablePostalCode: true,
            enableProvinces: false,
            postalCodeRegex: /^9[78][01]\d{2}$/,
            postalCodeFormats: null,
            provinces: []
        },
        {
            code: 'GQ',
            name: $localize`Equatorial Guinea`,
            enablePostalCode: false,
            enableProvinces: false,
            postalCodeRegex: null,
            postalCodeFormats: null,
            provinces: []
        },
        {
            code: 'GR',
            name: $localize`Greece`,
            enablePostalCode: true,
            enableProvinces: false,
            postalCodeRegex: /^\d{3} ?\d{2}$/,
            postalCodeFormats: null,
            provinces: []
        },
        {
            code: 'GS',
            name: $localize`South Georgia, South Sandwich Islands`,
            enablePostalCode: false,
            enableProvinces: false,
            postalCodeRegex: null,
            postalCodeFormats: null,
            provinces: []
        },
        {
            code: 'GT',
            name: $localize`Guatemala`,
            enablePostalCode: false,
            enableProvinces: false,
            postalCodeRegex: /^\d{5}$/,
            postalCodeFormats: null,
            provinces: []
        },
        {
            code: 'GU',
            name: $localize`Guam`,
            enablePostalCode: true,
            enableProvinces: false,
            postalCodeRegex: /^(969(?:[12]\d|3[12]))(?:[ \-](\d{4}))?$/,
            postalCodeFormats: null,
            provinces: []
        },
        {
            code: 'GW',
            name: $localize`Guinea-Bissau`,
            enablePostalCode: false,
            enableProvinces: false,
            postalCodeRegex: /^\d{4}$/,
            postalCodeFormats: null,
            provinces: []
        },
        {
            code: 'GY',
            name: $localize`Guyana`,
            enablePostalCode: false,
            enableProvinces: false,
            postalCodeRegex: null,
            postalCodeFormats: null,
            provinces: []
        },
        {
            code: 'HK',
            name: $localize`Hong Kong`,
            enablePostalCode: false,
            enableProvinces: false,
            postalCodeRegex: null,
            postalCodeFormats: null,
            provinces: []
        },
        {
            code: 'HM',
            name: $localize`Heard And Mc Donald Islands`,
            enablePostalCode: false,
            enableProvinces: false,
            postalCodeRegex: null,
            postalCodeFormats: null,
            provinces: []
        },
        {
            code: 'HN',
            name: $localize`Honduras`,
            enablePostalCode: false,
            enableProvinces: false,
            postalCodeRegex: /^(?:\d{5})?$/,
            postalCodeFormats: null,
            provinces: []
        },
        {
            code: 'HR',
            name: $localize`Croatia (Local Name: Hrvatska)`,
            enablePostalCode: true,
            enableProvinces: false,
            postalCodeRegex: /^\d{5}$/,
            postalCodeFormats: null,
            provinces: []
        },
        {
            code: 'HT',
            name: $localize`Haiti`,
            enablePostalCode: false,
            enableProvinces: false,
            postalCodeRegex: /^\d{4}$/,
            postalCodeFormats: null,
            provinces: []
        },
        {
            code: 'HU',
            name: $localize`Hungary`,
            enablePostalCode: true,
            enableProvinces: false,
            postalCodeRegex: /^\d{4}$/,
            postalCodeFormats: null,
            provinces: []
        },
        {
            code: 'IC',
            name: $localize`Canary Islands`,
            enablePostalCode: true,
            enableProvinces: false,
            postalCodeRegex: /^\d{5}$/,
            postalCodeFormats: 'NNNNN',
            provinces: []
        },
        {
            code: 'ID',
            name: $localize`Indonesia`,
            enablePostalCode: true,
            enableProvinces: false,
            postalCodeRegex: /^\d{5}$/,
            postalCodeFormats: null,
            provinces: []
        },
        {
            code: 'IE',
            name: $localize`Ireland`,
            enablePostalCode: true,
            enableProvinces: false,
            postalCodeRegex: /^^(?:[AC-FHKNPRTV-Y][0-9]{2}|D6W)[ -]?[0-9AC-FHKNPRTV-Y]{4}$$/,
            postalCodeFormats: 'AAA AAAA',
            provinces: []
        },
        {
            code: 'IL',
            name: $localize`Israel`,
            enablePostalCode: true,
            enableProvinces: false,
            postalCodeRegex: /^\d{5}(?:\d{2})?$/,
            postalCodeFormats: null,
            provinces: []
        },
        {
            code: 'IN',
            name: $localize`India`,
            enablePostalCode: true,
            enableProvinces: false,
            postalCodeRegex: /^\d{6}$/,
            postalCodeFormats: null,
            provinces: []
        },
        {
            code: 'IO',
            name: $localize`British Indian Ocean Territory`,
            enablePostalCode: false,
            enableProvinces: false,
            postalCodeRegex: null,
            postalCodeFormats: null,
            provinces: []
        },
        {
            code: 'IQ',
            name: $localize`Iraq`,
            enablePostalCode: false,
            enableProvinces: false,
            postalCodeRegex: /^\d{5}$/,
            postalCodeFormats: null,
            provinces: []
        },
        {
            code: 'IR',
            name: $localize`Iran (Islamic Republic Of)`,
            enablePostalCode: false,
            enableProvinces: false,
            postalCodeRegex: null,
            postalCodeFormats: null,
            provinces: []
        },
        {
            code: 'IS',
            name: $localize`Iceland`,
            enablePostalCode: true,
            enableProvinces: false,
            postalCodeRegex: /^\d{3}$/,
            postalCodeFormats: null,
            provinces: []
        },
        {
            code: 'IT',
            name: $localize`Italy`,
            enablePostalCode: true,
            enableProvinces: false,
            postalCodeRegex: /^\d{5}$/,
            postalCodeFormats: null,
            provinces: []
        },
        {
            code: 'JE',
            name: $localize`Jersey`,
            enablePostalCode: false,
            enableProvinces: false,
            postalCodeRegex: null,
            postalCodeFormats: null,
            provinces: []
        },
        {
            code: 'JM',
            name: $localize`Jamaica`,
            enablePostalCode: false,
            enableProvinces: false,
            postalCodeRegex: null,
            postalCodeFormats: null,
            provinces: []
        },
        {
            code: 'JO',
            name: $localize`Jordan`,
            enablePostalCode: false,
            enableProvinces: false,
            postalCodeRegex: /^\d{5}$/,
            postalCodeFormats: null,
            provinces: []
        },
        {
            code: 'JP',
            name: $localize`Japan`,
            enablePostalCode: true,
            enableProvinces: false,
            postalCodeRegex: /^\d{3}-?\d{4}$/,
            postalCodeFormats: null,
            provinces: []
        },
        {
            code: 'KE',
            name: $localize`Kenya`,
            enablePostalCode: false,
            enableProvinces: false,
            postalCodeRegex: /^\d{5}$/,
            postalCodeFormats: null,
            provinces: []
        },
        {
            code: 'KG',
            name: $localize`Kyrgyzstan`,
            enablePostalCode: true,
            enableProvinces: false,
            postalCodeRegex: /^\d{6}$/,
            postalCodeFormats: null,
            provinces: []
        },
        {
            code: 'KH',
            name: $localize`Cambodia`,
            enablePostalCode: true,
            enableProvinces: false,
            postalCodeRegex: /^\d{6}$/,
            postalCodeFormats: null,
            provinces: []
        },
        {
            code: 'KI',
            name: $localize`Kiribati`,
            enablePostalCode: false,
            enableProvinces: false,
            postalCodeRegex: null,
            postalCodeFormats: null,
            provinces: []
        },
        {
            code: 'KM',
            name: $localize`Comoros`,
            enablePostalCode: false,
            enableProvinces: false,
            postalCodeRegex: null,
            postalCodeFormats: null,
            provinces: []
        },
        {
            code: 'KN',
            name: $localize`Saint Kitts And Nevis`,
            enablePostalCode: false,
            enableProvinces: false,
            postalCodeRegex: null,
            postalCodeFormats: null,
            provinces: []
        },
        {
            code: 'KP',
            name: $localize`North Korea`,
            enablePostalCode: false,
            enableProvinces: false,
            postalCodeRegex: null,
            postalCodeFormats: null,
            provinces: []
        },
        {
            code: 'KR',
            name: $localize`South Korea`,
            enablePostalCode: true,
            enableProvinces: false,
            postalCodeRegex: /^\d{5}$/,
            postalCodeFormats: '11111',
            provinces: []
        },
        {
            code: 'KV',
            name: $localize`Kosovo`,
            enablePostalCode: false,
            enableProvinces: false,
            postalCodeRegex: null,
            postalCodeFormats: null,
            provinces: []
        },
        {
            code: 'KW',
            name: $localize`Kuwait`,
            enablePostalCode: false,
            enableProvinces: false,
            postalCodeRegex: /^\d{5}$/,
            postalCodeFormats: null,
            provinces: []
        },
        {
            code: 'KY',
            name: $localize`Cayman Islands`,
            enablePostalCode: false,
            enableProvinces: false,
            postalCodeRegex: /^KY\d-\d{4}$/,
            postalCodeFormats: null,
            provinces: []
        },
        {
            code: 'KZ',
            name: $localize`Kazakhstan`,
            enablePostalCode: true,
            enableProvinces: false,
            postalCodeRegex: /^\d{6}$/,
            postalCodeFormats: null,
            provinces: []
        },
        {
            code: 'LA',
            name: $localize`Lao People's Democratic Republic`,
            enablePostalCode: false,
            enableProvinces: false,
            postalCodeRegex: /^\d{5}$/,
            postalCodeFormats: null,
            provinces: []
        },
        {
            code: 'LB',
            name: $localize`Lebanon`,
            enablePostalCode: false,
            enableProvinces: false,
            postalCodeRegex: /^(?:(?:\d{4})(?:[ ]?(?:\d{4}))?)?$/,
            postalCodeFormats: null,
            provinces: []
        },
        {
            code: 'LC',
            name: $localize`Saint Lucia`,
            enablePostalCode: false,
            enableProvinces: false,
            postalCodeRegex: null,
            postalCodeFormats: null,
            provinces: []
        },
        {
            code: 'LI',
            name: $localize`Liechtenstein`,
            enablePostalCode: true,
            enableProvinces: false,
            postalCodeRegex: /^(948[5-9])|(949[0-7])$/,
            postalCodeFormats: null,
            provinces: []
        },
        {
            code: 'LK',
            name: $localize`Sri Lanka`,
            enablePostalCode: false,
            enableProvinces: false,
            postalCodeRegex: /^\d{5}$/,
            postalCodeFormats: null,
            provinces: []
        },
        {
            code: 'LR',
            name: $localize`Liberia`,
            enablePostalCode: false,
            enableProvinces: false,
            postalCodeRegex: /^\d{4}$/,
            postalCodeFormats: null,
            provinces: []
        },
        {
            code: 'LS',
            name: $localize`Lesotho`,
            enablePostalCode: false,
            enableProvinces: false,
            postalCodeRegex: /^\d{3}$/,
            postalCodeFormats: null,
            provinces: []
        },
        {
            code: 'LT',
            name: $localize`Lithuania`,
            enablePostalCode: true,
            enableProvinces: false,
            postalCodeRegex: /^\d{5}$/,
            postalCodeFormats: null,
            provinces: []
        },
        {
            code: 'LU',
            name: $localize`Luxembourg`,
            enablePostalCode: true,
            enableProvinces: false,
            postalCodeRegex: /^\d{4}$/,
            postalCodeFormats: null,
            provinces: []
        },
        {
            code: 'LV',
            name: $localize`Latvia`,
            enablePostalCode: true,
            enableProvinces: false,
            postalCodeRegex: /^\d{4}$/,
            postalCodeFormats: null,
            provinces: []
        },
        {
            code: 'LY',
            name: $localize`Libyan Arab Jamahiriya`,
            enablePostalCode: false,
            enableProvinces: false,
            postalCodeRegex: null,
            postalCodeFormats: null,
            provinces: []
        },
        {
            code: 'MA',
            name: $localize`Morocco`,
            enablePostalCode: true,
            enableProvinces: false,
            postalCodeRegex: /^\d{5}$/,
            postalCodeFormats: null,
            provinces: []
        },
        {
            code: 'MC',
            name: $localize`Monaco`,
            enablePostalCode: false,
            enableProvinces: false,
            postalCodeRegex: null,
            postalCodeFormats: null,
            provinces: []
        },
        {
            code: 'MD',
            name: $localize`Moldova, Republic Of`,
            enablePostalCode: false,
            enableProvinces: false,
            postalCodeRegex: null,
            postalCodeFormats: null,
            provinces: []
        },
        {
            code: 'ME',
            name: $localize`Montenegro`,
            enablePostalCode: false,
            enableProvinces: false,
            postalCodeRegex: null,
            postalCodeFormats: null,
            provinces: []
        },
        {
            code: 'MG',
            name: $localize`Madagascar`,
            enablePostalCode: true,
            enableProvinces: false,
            postalCodeRegex: /^\d{3}$/,
            postalCodeFormats: null,
            provinces: []
        },
        {
            code: 'MH',
            name: $localize`Marshall Islands`,
            enablePostalCode: true,
            enableProvinces: false,
            postalCodeRegex: /^(969[67]\d)(?:[ \-](\d{4}))?$/,
            postalCodeFormats: null,
            provinces: []
        },
        {
            code: 'MK',
            name: $localize`Macedonia, Former Yugoslav Republic Of`,
            enablePostalCode: true,
            enableProvinces: false,
            postalCodeRegex: /^\d{4}$/,
            postalCodeFormats: null,
            provinces: []
        },
        {
            code: 'ML',
            name: $localize`Mali`,
            enablePostalCode: false,
            enableProvinces: false,
            postalCodeRegex: null,
            postalCodeFormats: null,
            provinces: []
        },
        {
            code: 'MM',
            name: $localize`Myanmar`,
            enablePostalCode: false,
            enableProvinces: false,
            postalCodeRegex: null,
            postalCodeFormats: null,
            provinces: []
        },
        {
            code: 'MN',
            name: $localize`Mongolia`,
            enablePostalCode: true,
            enableProvinces: false,
            postalCodeRegex: /^\d{5}$/,
            postalCodeFormats: null,
            provinces: []
        },
        {
            code: 'MO',
            name: $localize`Macau`,
            enablePostalCode: false,
            enableProvinces: false,
            postalCodeRegex: null,
            postalCodeFormats: null,
            provinces: []
        },
        {
            code: 'MP',
            name: $localize`Northern Mariana Islands`,
            enablePostalCode: true,
            enableProvinces: false,
            postalCodeRegex: /^(9695[012])(?:[ \-](\d{4}))?$/,
            postalCodeFormats: null,
            provinces: []
        },
        {
            code: 'MQ',
            name: $localize`Martinique`,
            enablePostalCode: true,
            enableProvinces: false,
            postalCodeRegex: /^9[78]2\d{2}$/,
            postalCodeFormats: null,
            provinces: []
        },
        {
            code: 'MR',
            name: $localize`Mauritania`,
            enablePostalCode: false,
            enableProvinces: false,
            postalCodeRegex: null,
            postalCodeFormats: null,
            provinces: []
        },
        {
            code: 'MS',
            name: $localize`Montserrat`,
            enablePostalCode: false,
            enableProvinces: false,
            postalCodeRegex: null,
            postalCodeFormats: null,
            provinces: []
        },
        {
            code: 'MT',
            name: $localize`Malta`,
            enablePostalCode: false,
            enableProvinces: false,
            postalCodeRegex: /^[A-Z]{3}[ ]?\d{2,4}$/,
            postalCodeFormats: null,
            provinces: []
        },
        {
            code: 'MU',
            name: $localize`Mauritius`,
            enablePostalCode: false,
            enableProvinces: false,
            postalCodeRegex: /^(?:\d{3}[A-Z]{2}\d{3})?$/,
            postalCodeFormats: null,
            provinces: []
        },
        {
            code: 'MV',
            name: $localize`Maldives`,
            enablePostalCode: true,
            enableProvinces: false,
            postalCodeRegex: /^\d{5}$/,
            postalCodeFormats: null,
            provinces: []
        },
        {
            code: 'MW',
            name: $localize`Malawi`,
            enablePostalCode: false,
            enableProvinces: false,
            postalCodeRegex: null,
            postalCodeFormats: null,
            provinces: []
        },
        {
            code: 'MX',
            name: $localize`Mexico`,
            enablePostalCode: true,
            enableProvinces: false,
            postalCodeRegex: /^\d{5}$/,
            postalCodeFormats: null,
            provinces: []
        },
        {
            code: 'MY',
            name: $localize`Malaysia`,
            enablePostalCode: true,
            enableProvinces: false,
            postalCodeRegex: /^\d{5}$/,
            postalCodeFormats: null,
            provinces: []
        },
        {
            code: 'MZ',
            name: $localize`Mozambique`,
            enablePostalCode: false,
            enableProvinces: false,
            postalCodeRegex: /^\d{4}$/,
            postalCodeFormats: null,
            provinces: []
        },
        {
            code: 'NA',
            name: $localize`Namibia`,
            enablePostalCode: false,
            enableProvinces: false,
            postalCodeRegex: null,
            postalCodeFormats: null,
            provinces: []
        },
        {
            code: 'NC',
            name: $localize`New Caledonia`,
            enablePostalCode: true,
            enableProvinces: false,
            postalCodeRegex: null,
            postalCodeFormats: null,
            provinces: []
        },
        {
            code: 'NE',
            name: $localize`Niger`,
            enablePostalCode: false,
            enableProvinces: false,
            postalCodeRegex: /^\d{4}$/,
            postalCodeFormats: null,
            provinces: []
        },
        {
            code: 'NF',
            name: $localize`Norfolk Island`,
            enablePostalCode: false,
            enableProvinces: false,
            postalCodeRegex: null,
            postalCodeFormats: null,
            provinces: []
        },
        {
            code: 'NG',
            name: $localize`Nigeria`,
            enablePostalCode: false,
            enableProvinces: false,
            postalCodeRegex: /^(?:\d{6})?$/,
            postalCodeFormats: null,
            provinces: []
        },
        {
            code: 'NI',
            name: $localize`Nicaragua`,
            enablePostalCode: false,
            enableProvinces: false,
            postalCodeRegex: /^\d{5}$/,
            postalCodeFormats: null,
            provinces: []
        },
        {
            code: 'NL',
            name: $localize`Netherlands`,
            enablePostalCode: true,
            enableProvinces: false,
            postalCodeRegex: /^\d{4}[ ]?([A-Z]{2})?$/,
            postalCodeFormats: null,
            provinces: []
        },
        {
            code: 'NO',
            name: $localize`Norway`,
            enablePostalCode: true,
            enableProvinces: false,
            postalCodeRegex: /^\d{4}$/,
            postalCodeFormats: null,
            provinces: []
        },
        {
            code: 'NP',
            name: $localize`Nepal`,
            enablePostalCode: false,
            enableProvinces: false,
            postalCodeRegex: /^\d{5}$/,
            postalCodeFormats: null,
            provinces: []
        },
        {
            code: 'NR',
            name: $localize`Nauru`,
            enablePostalCode: false,
            enableProvinces: false,
            postalCodeRegex: null,
            postalCodeFormats: null,
            provinces: []
        },
        {
            code: 'NU',
            name: $localize`Niue`,
            enablePostalCode: false,
            enableProvinces: false,
            postalCodeRegex: null,
            postalCodeFormats: null,
            provinces: []
        },
        {
            code: 'NZ',
            name: $localize`New Zealand`,
            enablePostalCode: true,
            enableProvinces: false,
            postalCodeRegex: /^\d{4}$/,
            postalCodeFormats: null,
            provinces: []
        },
        {
            code: 'OM',
            name: $localize`Oman`,
            enablePostalCode: false,
            enableProvinces: false,
            postalCodeRegex: /^(PC )?\d{3}$/,
            postalCodeFormats: null,
            provinces: []
        },
        {
            code: 'PA',
            name: $localize`Panama`,
            enablePostalCode: false,
            enableProvinces: false,
            postalCodeRegex: null,
            postalCodeFormats: null,
            provinces: []
        },
        {
            code: 'PE',
            name: $localize`Peru`,
            enablePostalCode: false,
            enableProvinces: false,
            postalCodeRegex: /^(?:LIMA \d|CALLAO 0?)\d|[0-2]\d{4}$/,
            postalCodeFormats: null,
            provinces: []
        },
        {
            code: 'PF',
            name: $localize`French Polynesia`,
            enablePostalCode: false,
            enableProvinces: false,
            postalCodeRegex: null,
            postalCodeFormats: null,
            provinces: []
        },
        {
            code: 'PG',
            name: $localize`Papua New Guinea`,
            enablePostalCode: true,
            enableProvinces: false,
            postalCodeRegex: /^\d{3}$/,
            postalCodeFormats: null,
            provinces: []
        },
        {
            code: 'PH',
            name: $localize`Philippines`,
            enablePostalCode: true,
            enableProvinces: false,
            postalCodeRegex: /^\d{4}$/,
            postalCodeFormats: null,
            provinces: []
        },
        {
            code: 'PK',
            name: $localize`Pakistan`,
            enablePostalCode: true,
            enableProvinces: false,
            postalCodeRegex: /^\d{5}$/,
            postalCodeFormats: null,
            provinces: []
        },
        {
            code: 'PL',
            name: $localize`Poland`,
            enablePostalCode: true,
            enableProvinces: false,
            postalCodeRegex: /^\d{2}-\d{3}$/,
            postalCodeFormats: null,
            provinces: []
        },
        {
            code: 'PM',
            name: $localize`St. Pierre And Miquelon`,
            enablePostalCode: false,
            enableProvinces: false,
            postalCodeRegex: null,
            postalCodeFormats: null,
            provinces: []
        },
        {
            code: 'PN',
            name: $localize`Pitcairn`,
            enablePostalCode: false,
            enableProvinces: false,
            postalCodeRegex: null,
            postalCodeFormats: null,
            provinces: []
        },
        {
            code: 'PR',
            name: $localize`Puerto Rico`,
            enablePostalCode: true,
            enableProvinces: false,
            postalCodeRegex: /^(00[679]\d{2})(?:[ \-](\d{4}))?$/,
            postalCodeFormats: null,
            provinces: []
        },
        {
            code: 'PT',
            name: $localize`Portugal`,
            enablePostalCode: true,
            enableProvinces: false,
            postalCodeRegex: /^\d{4}(\-\d{3})?$/,
            postalCodeFormats: null,
            provinces: []
        },
        {
            code: 'PW',
            name: $localize`Palau`,
            enablePostalCode: true,
            enableProvinces: false,
            postalCodeRegex: /^(969(?:39|40))(?:[ \-](\d{4}))?$/,
            postalCodeFormats: null,
            provinces: []
        },
        {
            code: 'PY',
            name: $localize`Paraguay`,
            enablePostalCode: false,
            enableProvinces: false,
            postalCodeRegex: /^\d{4}$/,
            postalCodeFormats: null,
            provinces: []
        },
        {
            code: 'QA',
            name: $localize`Qatar`,
            enablePostalCode: false,
            enableProvinces: false,
            postalCodeRegex: null,
            postalCodeFormats: null,
            provinces: []
        },
        {
            code: 'RE',
            name: $localize`Reunion`,
            enablePostalCode: true,
            enableProvinces: false,
            postalCodeRegex: /^9[78]4\d{2}$/,
            postalCodeFormats: null,
            provinces: []
        },
        {
            code: 'RO',
            name: $localize`Romania`,
            enablePostalCode: true,
            enableProvinces: false,
            postalCodeRegex: /^\d{6}$/,
            postalCodeFormats: null,
            provinces: []
        },
        {
            code: 'RS',
            name: $localize`Serbia`,
            enablePostalCode: false,
            enableProvinces: false,
            postalCodeRegex: null,
            postalCodeFormats: null,
            provinces: []
        },
        {
            code: 'RU',
            name: $localize`Russian Federation`,
            enablePostalCode: true,
            enableProvinces: false,
            postalCodeRegex: /^\d{6}$/,
            postalCodeFormats: null,
            provinces: []
        },
        {
            code: 'RW',
            name: $localize`Rwanda`,
            enablePostalCode: false,
            enableProvinces: false,
            postalCodeRegex: null,
            postalCodeFormats: null,
            provinces: []
        },
        {
            code: 'SA',
            name: $localize`Saudi Arabia`,
            enablePostalCode: true,
            enableProvinces: false,
            postalCodeRegex: /^\d{5}$/,
            postalCodeFormats: null,
            provinces: []
        },
        {
            code: 'SB',
            name: $localize`Solomon Islands`,
            enablePostalCode: false,
            enableProvinces: false,
            postalCodeRegex: null,
            postalCodeFormats: null,
            provinces: []
        },
        {
            code: 'SC',
            name: $localize`Seychelles`,
            enablePostalCode: false,
            enableProvinces: false,
            postalCodeRegex: null,
            postalCodeFormats: null,
            provinces: []
        },
        {
            code: 'SD',
            name: $localize`Sudan`,
            enablePostalCode: false,
            enableProvinces: false,
            postalCodeRegex: null,
            postalCodeFormats: null,
            provinces: []
        },
        {
            code: 'SE',
            name: $localize`Sweden`,
            enablePostalCode: true,
            enableProvinces: false,
            postalCodeRegex: /^\d{3}[ ]?\d{2}$/,
            postalCodeFormats: null,
            provinces: []
        },
        {
            code: 'SG',
            name: $localize`Singapore`,
            enablePostalCode: true,
            enableProvinces: false,
            postalCodeRegex: /^\d{6}$/,
            postalCodeFormats: null,
            provinces: []
        },
        {
            code: 'SH',
            name: $localize`St. Helena`,
            enablePostalCode: true,
            enableProvinces: false,
            postalCodeRegex: /^(ASCN|STHL) 1ZZ$/,
            postalCodeFormats: null,
            provinces: []
        },
        {
            code: 'SI',
            name: $localize`Slovenia`,
            enablePostalCode: true,
            enableProvinces: false,
            postalCodeRegex: /^\d{4}$/,
            postalCodeFormats: null,
            provinces: []
        },
        {
            code: 'SJ',
            name: $localize`Svalbard And Jan Mayen Islands`,
            enablePostalCode: false,
            enableProvinces: false,
            postalCodeRegex: null,
            postalCodeFormats: null,
            provinces: []
        },
        {
            code: 'SK',
            name: $localize`Slovakia (Slovak Republic)`,
            enablePostalCode: true,
            enableProvinces: false,
            postalCodeRegex: /^\d{3}[ ]?\d{2}$/,
            postalCodeFormats: null,
            provinces: []
        },
        {
            code: 'SL',
            name: $localize`Sierra Leone`,
            enablePostalCode: false,
            enableProvinces: false,
            postalCodeRegex: null,
            postalCodeFormats: null,
            provinces: []
        },
        {
            code: 'SM',
            name: $localize`San Marino`,
            enablePostalCode: true,
            enableProvinces: false,
            postalCodeRegex: null,
            postalCodeFormats: null,
            provinces: []
        },
        {
            code: 'SN',
            name: $localize`Senegal`,
            enablePostalCode: false,
            enableProvinces: false,
            postalCodeRegex: null,
            postalCodeFormats: null,
            provinces: []
        },
        {
            code: 'SO',
            name: $localize`Somalia`,
            enablePostalCode: false,
            enableProvinces: false,
            postalCodeRegex: null,
            postalCodeFormats: null,
            provinces: []
        },
        {
            code: 'SR',
            name: $localize`Suriname`,
            enablePostalCode: false,
            enableProvinces: false,
            postalCodeRegex: null,
            postalCodeFormats: null,
            provinces: []
        },
        {
            code: 'SS',
            name: $localize`South Sudan`,
            enablePostalCode: false,
            enableProvinces: false,
            postalCodeRegex: null,
            postalCodeFormats: null,
            provinces: []
        },
        {
            code: 'ST',
            name: $localize`Sao Tome And Principe`,
            enablePostalCode: false,
            enableProvinces: false,
            postalCodeRegex: null,
            postalCodeFormats: null,
            provinces: []
        },
        {
            code: 'SV',
            name: $localize`El Salvador`,
            enablePostalCode: false,
            enableProvinces: false,
            postalCodeRegex: /^CP [1-3][1-7][0-2]\d$/,
            postalCodeFormats: null,
            provinces: []
        },
        {
            code: 'SY',
            name: $localize`Syrian Arab Republic`,
            enablePostalCode: false,
            enableProvinces: false,
            postalCodeRegex: null,
            postalCodeFormats: null,
            provinces: []
        },
        {
            code: 'SZ',
            name: $localize`Swaziland`,
            enablePostalCode: true,
            enableProvinces: false,
            postalCodeRegex: /^[HLMS]\d{3}$/,
            postalCodeFormats: null,
            provinces: []
        },
        {
            code: 'TC',
            name: $localize`Turks And Caicos Islands`,
            enablePostalCode: false,
            enableProvinces: false,
            postalCodeRegex: /^TKCA 1ZZ$/,
            postalCodeFormats: null,
            provinces: []
        },
        {
            code: 'TD',
            name: $localize`Chad`,
            enablePostalCode: false,
            enableProvinces: false,
            postalCodeRegex: null,
            postalCodeFormats: null,
            provinces: []
        },
        {
            code: 'TF',
            name: $localize`French Southern Territories`,
            enablePostalCode: false,
            enableProvinces: false,
            postalCodeRegex: null,
            postalCodeFormats: null,
            provinces: []
        },
        {
            code: 'TG',
            name: $localize`Togo`,
            enablePostalCode: false,
            enableProvinces: false,
            postalCodeRegex: null,
            postalCodeFormats: null,
            provinces: []
        },
        {
            code: 'TH',
            name: $localize`Thailand`,
            enablePostalCode: true,
            enableProvinces: false,
            postalCodeRegex: /^\d{5}$/,
            postalCodeFormats: null,
            provinces: []
        },
        {
            code: 'TJ',
            name: $localize`Tajikistan`,
            enablePostalCode: true,
            enableProvinces: false,
            postalCodeRegex: /^\d{6}$/,
            postalCodeFormats: null,
            provinces: []
        },
        {
            code: 'TK',
            name: $localize`Tokelau`,
            enablePostalCode: false,
            enableProvinces: false,
            postalCodeRegex: null,
            postalCodeFormats: null,
            provinces: []
        },
        {
            code: 'TL',
            name: $localize`TL`,
            enablePostalCode: false,
            enableProvinces: false,
            postalCodeRegex: null,
            postalCodeFormats: null,
            provinces: []
        },
        {
            code: 'TM',
            name: $localize`Turkmenistan`,
            enablePostalCode: false,
            enableProvinces: false,
            postalCodeRegex: null,
            postalCodeFormats: null,
            provinces: []
        },
        {
            code: 'TN',
            name: $localize`Tunisia`,
            enablePostalCode: true,
            enableProvinces: false,
            postalCodeRegex: null,
            postalCodeFormats: null,
            provinces: []
        },
        {
            code: 'TO',
            name: $localize`Tonga`,
            enablePostalCode: false,
            enableProvinces: false,
            postalCodeRegex: null,
            postalCodeFormats: null,
            provinces: []
        },
        {
            code: 'TP',
            name: $localize`East Timor`,
            enablePostalCode: false,
            enableProvinces: false,
            postalCodeRegex: null,
            postalCodeFormats: null,
            provinces: []
        },
        {
            code: 'TR',
            name: $localize`Turkey`,
            enablePostalCode: true,
            enableProvinces: false,
            postalCodeRegex: /^\d{5}$/,
            postalCodeFormats: null,
            provinces: []
        },
        {
            code: 'TS',
            name: $localize`Timor-Leste`,
            enablePostalCode: false,
            enableProvinces: false,
            postalCodeRegex: null,
            postalCodeFormats: null,
            provinces: []
        },
        {
            code: 'TT',
            name: $localize`Trinidad And Tobago`,
            enablePostalCode: false,
            enableProvinces: false,
            postalCodeRegex: null,
            postalCodeFormats: null,
            provinces: []
        },
        {
            code: 'TV',
            name: $localize`Tuvalu`,
            enablePostalCode: false,
            enableProvinces: false,
            postalCodeRegex: null,
            postalCodeFormats: null,
            provinces: []
        },
        {
            code: 'TW',
            name: $localize`Taiwan`,
            enablePostalCode: true,
            enableProvinces: false,
            postalCodeRegex: /^\d{3}(\d{2})?$/,
            postalCodeFormats: null,
            provinces: []
        },
        {
            code: 'TZ',
            name: $localize`Tanzania, United Republic Of`,
            enablePostalCode: false,
            enableProvinces: false,
            postalCodeRegex: /^\d{4}$/,
            postalCodeFormats: null,
            provinces: []
        },
        {
            code: 'UA',
            name: $localize`Ukraine`,
            enablePostalCode: true,
            enableProvinces: false,
            postalCodeRegex: /^\d{5}$/,
            postalCodeFormats: null,
            provinces: []
        },
        {
            code: 'UG',
            name: $localize`Uganda`,
            enablePostalCode: false,
            enableProvinces: false,
            postalCodeRegex: null,
            postalCodeFormats: null,
            provinces: []
        },
        {
            code: 'UM',
            name: $localize`United States Minor Outlying Islands`,
            enablePostalCode: false,
            enableProvinces: false,
            postalCodeRegex: null,
            postalCodeFormats: null,
            provinces: []
        },
        {
            code: 'US',
            name: $localize`United States`,
            enablePostalCode: true,
            enableProvinces: true,
            postalCodeRegex: /^(\d{5})(?:[ \-](\d{4}))?$/,
            postalCodeFormats: null,
            provinces: [
                { code: 'AL', name: $localize`Alabama` },
                { code: 'AK', name: $localize`Alaska` },
                { code: 'AS', name: $localize`American Samoa` },
                { code: 'AZ', name: $localize`Arizona` },
                { code: 'AR', name: $localize`Arkansas` },
                { code: 'AA', name: $localize`Armed Forces (AA)` },
                { code: 'AE', name: $localize`Armed Forces (AE)` },
                { code: 'AP', name: $localize`Armed Forces (AP)` },
                { code: 'CA', name: $localize`California` },
                { code: 'CO', name: $localize`Colorado` },
                { code: 'CT', name: $localize`Connecticut` },
                { code: 'DE', name: $localize`Delaware` },
                { code: 'DC', name: $localize`District of Columbia` },
                { code: 'FL', name: $localize`Florida` },
                { code: 'GA', name: $localize`Georgia` },
                { code: 'GU', name: $localize`Guam` },
                { code: 'HI', name: $localize`Hawaii` },
                { code: 'ID', name: $localize`Idaho` },
                { code: 'IL', name: $localize`Illinois` },
                { code: 'IN', name: $localize`Indiana` },
                { code: 'IA', name: $localize`Iowa` },
                { code: 'KS', name: $localize`Kansas` },
                { code: 'KY', name: $localize`Kentucky` },
                { code: 'LA', name: $localize`Louisiana` },
                { code: 'ME', name: $localize`Maine` },
                { code: 'MH', name: $localize`Marshall Islands` },
                { code: 'MD', name: $localize`Maryland` },
                { code: 'MA', name: $localize`Massachusetts` },
                { code: 'MI', name: $localize`Michigan` },
                { code: 'FM', name: $localize`Micronesia` },
                { code: 'MN', name: $localize`Minnesota` },
                { code: 'MS', name: $localize`Mississippi` },
                { code: 'MO', name: $localize`Missouri` },
                { code: 'MT', name: $localize`Montana` },
                { code: 'NE', name: $localize`Nebraska` },
                { code: 'NV', name: $localize`Nevada` },
                { code: 'NH', name: $localize`New Hampshire` },
                { code: 'NJ', name: $localize`New Jersey` },
                { code: 'NM', name: $localize`New Mexico` },
                { code: 'NY', name: $localize`New York` },
                { code: 'NC', name: $localize`North Carolina` },
                { code: 'ND', name: $localize`North Dakota` },
                { code: 'MP', name: $localize`Northern Mariana Islands` },
                { code: 'OH', name: $localize`Ohio` },
                { code: 'OK', name: $localize`Oklahoma` },
                { code: 'OR', name: $localize`Oregon` },
                { code: 'PW', name: $localize`Palau` },
                { code: 'PA', name: $localize`Pennsylvania` },
                { code: 'PR', name: $localize`Puerto Rico` },
                { code: 'RI', name: $localize`Rhode Island` },
                { code: 'SC', name: $localize`South Carolina` },
                { code: 'SD', name: $localize`South Dakota` },
                { code: 'TN', name: $localize`Tennessee` },
                { code: 'TX', name: $localize`Texas` },
                { code: 'UT', name: $localize`Utah` },
                { code: 'VT', name: $localize`Vermont` },
                { code: 'VI', name: $localize`Virgin Islands` },
                { code: 'VA', name: $localize`Virginia` },
                { code: 'WA', name: $localize`Washington` },
                { code: 'WV', name: $localize`West Virginia` },
                { code: 'WI', name: $localize`Wisconsin` },
                { code: 'WY', name: $localize`Wyoming` }
            ]
        },
        {
            code: 'UY',
            name: $localize`Uruguay`,
            enablePostalCode: false,
            enableProvinces: false,
            postalCodeRegex: /^\d{5}$/,
            postalCodeFormats: null,
            provinces: []
        },
        {
            code: 'UZ',
            name: $localize`Uzbekistan`,
            enablePostalCode: true,
            enableProvinces: false,
            postalCodeRegex: /^\d{6}$/,
            postalCodeFormats: null,
            provinces: []
        },
        {
            code: 'VA',
            name: $localize`Holy See (Vatican City State)`,
            enablePostalCode: false,
            enableProvinces: false,
            postalCodeRegex: null,
            postalCodeFormats: null,
            provinces: []
        },
        {
            code: 'VC',
            name: $localize`Saint Vincent And The Grenadines`,
            enablePostalCode: false,
            enableProvinces: false,
            postalCodeRegex: /^VC\d{4}$/,
            postalCodeFormats: null,
            provinces: []
        },
        {
            code: 'VE',
            name: $localize`Venezuela`,
            enablePostalCode: false,
            enableProvinces: false,
            postalCodeRegex: /^\d{4}$/,
            postalCodeFormats: null,
            provinces: []
        },
        {
            code: 'VG',
            name: $localize`Virgin Islands (British)`,
            enablePostalCode: false,
            enableProvinces: false,
            postalCodeRegex: /^VG\d{4}$/,
            postalCodeFormats: null,
            provinces: []
        },
        {
            code: 'VI',
            name: $localize`Virgin Islands (U.S.)`,
            enablePostalCode: true,
            enableProvinces: false,
            postalCodeRegex: /^(008(?:(?:[0-4]\d)|(?:5[01])))(?:[ \-](\d{4}))?$/,
            postalCodeFormats: null,
            provinces: []
        },
        {
            code: 'VN',
            name: $localize`Vietnam`,
            enablePostalCode: false,
            enableProvinces: false,
            postalCodeRegex: /^\d{6}$/,
            postalCodeFormats: 'NNNNNN',
            provinces: []
        },
        {
            code: 'VU',
            name: $localize`Vanuatu`,
            enablePostalCode: false,
            enableProvinces: false,
            postalCodeRegex: null,
            postalCodeFormats: null,
            provinces: []
        },
        {
            code: 'WF',
            name: $localize`Wallis And Futuna Islands`,
            enablePostalCode: false,
            enableProvinces: false,
            postalCodeRegex: null,
            postalCodeFormats: null,
            provinces: []
        },
        {
            code: 'WS',
            name: $localize`Samoa`,
            enablePostalCode: false,
            enableProvinces: false,
            postalCodeRegex: null,
            postalCodeFormats: null,
            provinces: []
        },
        {
            code: 'XB',
            name: $localize`Great Britain`,
            enablePostalCode: false,
            enableProvinces: false,
            postalCodeRegex: null,
            postalCodeFormats: null,
            provinces: []
        },
        {
            code: 'CW',
            name: $localize`Curacao`,
            enablePostalCode: false,
            enableProvinces: false,
            postalCodeRegex: null,
            postalCodeFormats: null,
            provinces: []
        },
        {
            code: 'XE',
            name: $localize`St. Eustatius`,
            enablePostalCode: false,
            enableProvinces: false,
            postalCodeRegex: null,
            postalCodeFormats: null,
            provinces: []
        },
        {
            code: 'XI',
            name: $localize`Northern Island`,
            enablePostalCode: false,
            enableProvinces: false,
            postalCodeRegex: null,
            postalCodeFormats: null,
            provinces: []
        },
        {
            code: 'XN',
            name: $localize`Northern Mariana Islands`,
            enablePostalCode: false,
            enableProvinces: false,
            postalCodeRegex: null,
            postalCodeFormats: null,
            provinces: []
        },
        {
            code: 'XS',
            name: $localize`Serbia`,
            enablePostalCode: false,
            enableProvinces: false,
            postalCodeRegex: null,
            postalCodeFormats: null,
            provinces: []
        },
        {
            code: 'XY',
            name: $localize`XY`,
            enablePostalCode: false,
            enableProvinces: false,
            postalCodeRegex: null,
            postalCodeFormats: null,
            provinces: []
        },
        {
            code: 'YE',
            name: $localize`Yemen`,
            enablePostalCode: false,
            enableProvinces: false,
            postalCodeRegex: null,
            postalCodeFormats: null,
            provinces: []
        },
        {
            code: 'YT',
            name: $localize`Mayotte`,
            enablePostalCode: true,
            enableProvinces: false,
            postalCodeRegex: null,
            postalCodeFormats: null,
            provinces: []
        },
        {
            code: 'YU',
            name: $localize`Yugoslavia`,
            enablePostalCode: false,
            enableProvinces: false,
            postalCodeRegex: null,
            postalCodeFormats: null,
            provinces: []
        },
        {
            code: 'ZA',
            name: $localize`South Africa`,
            enablePostalCode: true,
            enableProvinces: false,
            postalCodeRegex: /^\d{4}$/,
            postalCodeFormats: null,
            provinces: []
        },
        {
            code: 'ZM',
            name: $localize`Zambia`,
            enablePostalCode: false,
            enableProvinces: false,
            postalCodeRegex: /^\d{5}$/,
            postalCodeFormats: null,
            provinces: []
        },
        {
            code: 'ZW',
            name: $localize`Zimbabwe`,
            enablePostalCode: false,
            enableProvinces: false,
            postalCodeRegex: null,
            postalCodeFormats: null,
            provinces: []
        },
        {
            code: 'MF',
            name: $localize`Saint Martin`,
            enablePostalCode: false,
            enableProvinces: false,
            postalCodeRegex: null,
            postalCodeFormats: null,
            provinces: []
        },
        {
            code: 'SX',
            name: $localize`St. Maarten`,
            enablePostalCode: false,
            enableProvinces: false,
            postalCodeRegex: null,
            postalCodeFormats: null,
            provinces: []
        },
        {
            code: 'PS',
            name: $localize`Palestine Autonomous`,
            enablePostalCode: false,
            enableProvinces: false,
            postalCodeRegex: null,
            postalCodeFormats: null,
            provinces: []
        }
    ];
